import React, { useState, useEffect, useRef } from 'react'
import { Address } from "./Addres"
import { PersonalData } from "./PersonalData"
import { GenericInput } from '../../LeasingInfo/components/GenericInput'
import { Calendar } from 'primereact/calendar'
import { Controller } from 'react-hook-form'
import { getZipCode } from '../../../Step1/getZipCode'
import { estados } from '../../../../../../Utils'

export const InfoTypePerson = ({ typePerson, control, register, defaultVals, errors, setValue, setLoading, setGetZipCode, watch, trigger }) => {
    const [columns, setColumns] = useState(window.innerWidth >= 768 ? '1fr 1fr' : '1fr');

    // useEffect(() => {
    //     // Campos de persona física
    //     const personaFisicaFields = [
    //         'firstName',
    //         'secondName',
    //         'paternal',
    //         'maternal',
    //         'birthday'
    //     ];

    //     // Campos de persona moral
    //     const personaMoralFields = [
    //         'isMoralPersonName',
    //         'ApellidoPaterno',
    //         'ApellidoMaterno',
    //         'NumeroIdentificacion',
    //         'fechaNacimiento',
    //         'name',
    //         'rfc',
    //         'fechaConstitucion'
    //     ];

    //     // Limpiar campos según el tipo de persona
    //     if (typePerson === 1) {
    //         personaMoralFields.forEach(field => {
    //             setValue(field, '');
    //         });
    //     } else if (typePerson === 2) {
    //         personaFisicaFields.forEach(field => {
    //             setValue(field, '');
    //         });
    //     }
    // }, [typePerson, setValue]);

    useEffect(() => {
        const handleResize = () => {
            setColumns(window.innerWidth >= 768 ? '1fr 1fr' : '1fr');
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const names = typePerson === 2 && ['isMoralPersonName', 'isMoralPersonRfc', 'isMoralPersonCiec', 'isMoralPersonEmail', 'isMoralPersonConfirmEmail'];
    const placeholders = typePerson === 2 && ['Nombre del representante', 'RFC con homoclave', 'Clave Ciec', 'Telefono', 'Correo electrónico', 'Confirma correo electrónico'];
    const tooltipName = typePerson === 2 ? 'Nombre del representante' : 'Coloca el nombre de la empresa tal como aparece en la constancia fiscal'

    const debounceTimeout = useRef(null);  // Ref para manejar el timeout
    const [coloniesFiltered, setColoniesFiltered] = useState([]); // Estado para almacenar las colonias filtradas

    const handleAutoCompleteAddress = async (value) => {
        const data = value;
        if (debounceTimeout.current) {
            clearTimeout(debounceTimeout.current);
        }

        debounceTimeout.current = setTimeout(async () => {
            if (data === null || data === undefined || data.length === 0) return;
            setLoading(true);
            setGetZipCode(true);

            try {
                const res = await getZipCode(data);

                if (res === null || !res.data) {
                    setLoading(false);
                    setGetZipCode(false);
                    setColoniesFiltered([]);
                    setValue('estado', '');
                    setValue('municipio', '');
                    setValue('colonia', '');
                    setValue('city', '');
                    return;
                }

                setLoading(false);
                setGetZipCode(false);

                // Mapeo de estados con acentos a versiones sin acentos
                const estadoMapping = {
                    'CDMX': 'Ciudad de Mexico',
                    'MÉXICO': 'Estado de Mexico',
                    'M\u00e9xico': 'Estado de Mexico',
                    'Michoac\u00e1n': 'Michoacan',
                    'Querétaro': 'Queretaro',
                    'Yucatán': 'Yucatan',
                    'Nuevo León': 'Nuevo Leon',
                    'San Luis Potosí': 'San Luis Potosi'
                };

                // Establecer el estado mapeado o el original
                const estadoValue = estadoMapping[res.data[0].estado] || res.data[0].estado;

                // Usar setValue con opciones para forzar la actualización del formulario
                setValue('estado', estadoValue, {
                    shouldValidate: true,
                    shouldDirty: true,
                    shouldTouch: true
                });

                setValue('municipio', res.data[0].municipio, {
                    shouldValidate: true,
                    shouldDirty: true,
                    shouldTouch: true
                });

                setColoniesFiltered(
                    res.data.map((item, index) => ({
                        id: index + 1,           // Asignar un ID basado en el índice
                        colonia: item.colonia.toUpperCase(),   // Guardar el nombre de la colonia
                        label: item.colonia.toUpperCase(),    // Guardar el nombre de la colonia
                    }))
                );

                setValue('city', res.data[0].municipio, {
                    shouldValidate: true,
                    shouldDirty: true,
                    shouldTouch: true
                });

            } catch (error) {
                console.error("Error al obtener código postal:", error);
                setLoading(false);
                setGetZipCode(false);
            }
        }, 800);
    };


    return (
        <div className="flex flex-col gap-2 w-full felx-col justify-center no-uppercase-inputs"
            style={{
                flexDirection: 'column',
                alignItems: 'center',
            }}
        >
            <style>{`
                .no-uppercase-inputs .Input, .no-uppercase-inputs input {
                    text-transform: none !important;
                }
            `}</style>
            {(typePerson === 1 || typePerson === 3) && (
                <>
                    <PersonalData control={control} register={register} defaultVals={defaultVals} errors={errors} setValue={setValue} handleAutoCompleteAddress={handleAutoCompleteAddress} watch={watch} typePerson={typePerson} trigger={trigger} />
                </>
            )}


            {typePerson === 2 && (
                <>
                    <div className="InputsDiv w-[60%] mx-auto">
                        <div className={`TextContainer mt-4`}>
                            Ingresa los datos del representante legal
                            <br />
                        </div>
                        <div className="ResponsiveContainer mt-5">
                            <div style={{
                                display: 'grid',
                                columnGap: '2vw',
                                rowGap: '1.8rem',
                                gridTemplateColumns: columns,
                                margin: '0 auto',
                            }}>
                                <GenericInput
                                    register={register}
                                    name={names[0]}
                                    placeholder={placeholders[0]}
                                    maxLength={50}
                                    tooltip={tooltipName}
                                    errors={errors}
                                    setValue={setValue}
                                    className="TextInput"
                                    required={typePerson === 2}
                                />
                                <GenericInput
                                    register={register}
                                    name={'secondName'}
                                    placeholder={'Segundo nombre'}
                                    maxLength={50}
                                    tooltip={tooltipName}
                                    errors={errors}
                                    setValue={setValue}
                                    className="TextInput"
                                    required={false}
                                />
                                <GenericInput
                                    register={register}
                                    name="ApellidoPaterno"
                                    placeholder="*Apellido paterno"
                                    maxLength={50}
                                    tooltip="*Apellido paterno"
                                    errors={errors}
                                    setValue={setValue}
                                    className="TextInput"
                                    required={typePerson === 2}
                                />
                                <GenericInput
                                    register={register}
                                    name="ApellidoMaterno"
                                    placeholder="Apellido materno"
                                    maxLength={50}
                                    tooltip="Apellido materno"
                                    errors={errors}
                                    setValue={setValue}
                                    className="TextInput"
                                    required={typePerson === 2}
                                />
                                {/*  <GenericInput
                                    register={register}
                                    name="NumeroIdentificacion"
                                    placeholder="Número de identificación"
                                    maxLength={50}
                                    tooltip="Número de identificación"
                                    errors={errors}
                                    setValue={setValue}
                                    className="TextInput"
                                    required={false}
                                /> */}
                                <Controller
                                    name="fechaNacimiento"
                                    control={control}
                                    render={({ field }) => (
                                        <Calendar

                                            inputId="fechaNacimiento"
                                            value={field.value}
                                            onChange={(e) => field.onChange(e.value)}
                                            placeholder="Fecha de nacimiento"
                                            showIcon
                                            className=" rounded-lg Input"
                                            maxDate={new Date()}
                                            required={typePerson === 2}
                                            style={{
                                                borderRadius: '17px',
                                                overflow: 'hidden',
                                                padding: '0',
                                                // height: '47px ',
                                                '& input': {
                                                    padding: '0.5rem 1rem',
                                                    borderRadius: '0px',
                                                }
                                            }}
                                            panelStyle={{
                                                borderRadius: '17px'
                                            }}
                                        />
                                    )}
                                />


                                <GenericInput register={register} name={names[1]} placeholder="RFC con homoclave" maxLength={13} tooltip=" RFC con homoclave" errors={errors} setValue={setValue} className="TextInput" required={true} />
                                <GenericInput register={register}
                                    name={"isMoralPersonCiec"}
                                    placeholder=" Clave Ciec"
                                    maxLength={40}
                                    tooltip="🔒 Completamente segura y no se compartira"
                                    errors={errors} setValue={setValue}
                                    type="password" className="TextInput"
                                    required={true}
                                    minLength={8}
                                />

                                {/* email representrante */}
                                <GenericInput register={register} name={"emailRepresentante"} placeholder="Correo electrónico" maxLength={50} tooltip="Correo electrónico" errors={errors} setValue={setValue} className="TextInput" required={true} />
                                {/* numero de telefono */}
                                <GenericInput register={register} name={"phoneRepresentante"} placeholder="Telefono" maxLength={13} tooltip="Telefono" errors={errors} setValue={setValue} className="TextInput" required={true} />

                                {/* <GenericInput register={register} name={names[3]} placeholder="Telefono" maxLength={13} tooltip="Telefono" errors={errors} setValue={setValue} className="TextInput" required = {true} />
                                <GenericInput register={register} name={names[4]} placeholder="Correo electrónico" tooltip="Correo electrónico" errors={errors} pattern={/^[^\s@]+@[^\s@]+\.[^\s@]+$/} setValue={setValue} className="TextInput" />
                                <GenericInput register={register} name={names[5]} placeholder="Confirma correo electrónico" tooltip="Confirma correo electrónico" errors={errors} pattern={/^[^\s@]+@[^\s@]+\.[^\s@]+$/} setValue={setValue} className="TextInput" /> */}
                            </div>
                        </div>
                    </div>

                    <div className="InputsDiv w-[60%] mx-auto">
                        <div className={`TextContainer mt-4`}>
                            Ingresa los datos de la empresa
                            <br />
                        </div>
                        <div className="ResponsiveContainer mt-5">
                            <div style={{
                                display: 'grid',
                                columnGap: '2vw',
                                rowGap: '1.8rem',
                                gridTemplateColumns: columns,
                                width: '100%',
                                margin: '0 auto',
                            }}>
                                <GenericInput register={register} name="name" placeholder="Nombre de la empresa o razón social" maxLength={50} tooltip="Nombre de la empresa o razón social" errors={errors} setValue={setValue} className="TextInput" required={true} />
                                {/* <GenericInput register={register} name="rfc" placeholder="RFC" maxLength={13} tooltip=" RFC" errors={errors} setValue={setValue} className="TextInput" required={true} /> */}
                                <Controller
                                    name="fechaConstitucion"
                                    control={control}
                                    render={({ field }) => (
                                        <Calendar
                                            inputId="fechaConstitucion"
                                            value={field.value}
                                            onChange={(e) => field.onChange(e.value)}
                                            placeholder="Fecha de constitución"
                                            showIcon
                                            required={true}
                                            className=" w-full rounded-lg Input"
                                            maxDate={new Date()}
                                            style={{
                                                borderRadius: '17px',
                                                overflow: 'hidden',
                                                padding: '0',
                                                width: '300px',
                                                // height: '47px',
                                                '& input': {
                                                    padding: '0.5rem 1rem',
                                                    borderRadius: '0px',
                                                }
                                            }}
                                            panelStyle={{
                                                borderRadius: '17px'
                                            }}
                                        />
                                    )}
                                />

                                <GenericInput
                                    register={register}
                                    name="rfcSyntage"
                                    placeholder="RFC con homoclave"
                                    maxLength={13}
                                    tooltip="RFC con homoclave"
                                    errors={errors}
                                    setValue={setValue}
                                    className="TextInput"
                                    required={true}
                                />

                                <GenericInput register={register}
                                    name={"ciecSyntage"}
                                    placeholder=" Clave Ciec"
                                    maxLength={40}
                                    tooltip="🔒 Completamente segura y no se compartira"
                                    errors={errors} setValue={setValue}
                                    type="password" className="TextInput"
                                    required={true}
                                    minLength={8}
                                />

                                {/* email empresa */}
                                <GenericInput register={register} name={"email"} placeholder="Correo electrónico" maxLength={50} tooltip="Correo electrónico" errors={errors} setValue={setValue} className="TextInput" required={true} />
                                {/* numero de telefono */}
                                <GenericInput register={register} name={"phone"} placeholder="Telefono" maxLength={13} tooltip="Telefono" errors={errors} setValue={setValue} className="TextInput" required={true} />



                            </div>
                        </div>
                    </div>

                </>
            )}

            {typePerson === 1 && (
                <div className="InputsDiv w-[60%] mx-auto">
                    <div className={`TextContainer mt-4`}>
                        Ingresa los datos para Syntage  <span style={{ fontSize: "15px" }} > <br />(Es seguro y no se compartirá)</span>
                        <br />
                        <div style={{
                            fontSize: "13px",
                            color: "#666",
                            marginTop: "8px",
                            lineHeight: "1.4",
                            fontStyle: "italic",
                            maxWidth: "400px",
                            textAlign: "center",
                            margin: "0 auto"
                        }}>
                            Syntage es una plataforma de verificación de identidad que nos ayuda a validar
                            tu información de forma segura y rápida. Tus datos están protegidos con encriptación.
                        </div>
                    </div>
                    <div className="ResponsiveContainer mt-5"></div>

                    <div className={`w-[60%] mx-auto ResponsiveContainer`} style={{
                        justifyContent: "center",
                        gap: '1rem 2vw',
                        margin: '0 auto',
                        display: 'flex',
                        alignItems: 'center',
                    }}>



                        <GenericInput
                            register={register}
                            name="rfcSyntage"
                            placeholder="RFC con homoclave"
                            maxLength={13}
                            tooltip="RFC con homoclave"
                            errors={errors}
                            setValue={setValue}
                            className="TextInput"
                            required={true}
                        />


                        <GenericInput register={register}
                            name={"ciecSyntage"}
                            placeholder="Clave CIEC (contraseña SAT)"
                            maxLength={40}
                            tooltip="🔒 Completamente segura y no se compartira"
                            errors={errors} setValue={setValue}
                            type="password" className="TextInput"
                            required={true}
                            minLength={8}
                        />
                    </div>
                </div>
            )}

            <Address register={register} control={control} defaultVals={defaultVals} errors={errors} typePerson={typePerson} setValue={setValue} handleAutoCompleteAddress={handleAutoCompleteAddress} coloniesFiltered={coloniesFiltered} />

        </div>
    )
}
